/* eslint-disable */
export default {
  feedbackHeader: '提交意見回饋',
  back: '返回',
  revert: '回復',
  instruction:
    '您的意見回饋對我們相當重要。若您在使用應用程式時有問題、想要求某項功能或是回報程式錯誤，我們非常樂意提供協助。',
  fillForm: '請填寫以下表格並按一下 ',
  useMailBox: ' 或直接使用您的信箱，將要求寄至 ',
  email: '您的電子郵件地址',
  reply: '（以便我們連絡您）',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: '意見回饋主題',
  topicPlaceHolder: '請選擇一個選項',
  bugReport: '錯誤回報',
  featureRequest: '功能要求',
  others: '其他',
  subject: '主旨',
  subjectPlaceHolder: '讓我們知道如何為您提供協助',
  description: '完整說明',
  descriptionPlaceHolder: '請盡可能列出最多資訊',
  send: '傳送您的意見回饋',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
